import { RecipeType } from '~/src/common/typings/product';

import { Tag } from './layout';

const TypeTag = ({ recipeType }: { recipeType: RecipeType }) => {
  return <Tag $color={recipeType.color}>{recipeType.label}</Tag>;
};

export default TypeTag;
